export const getListOfGatewayAndPriceWhatsapp = {
  GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_REQUEST: "GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_REQUEST",
  GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_SUCCESS: "GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_SUCCESS",
  GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_ERROR: "GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_ERROR",
};


export const getListOfWhatsappPrice2 = {
  GET_LIST_OF_WHATSAPP_PRICE_2_REQUEST: "GET_LIST_OF_WHATSAPP_PRICE_2_REQUEST",
  GET_LIST_OF_WHATSAPP_PRICE_2_SUCCESS: "GET_LIST_OF_WHATSAPP_PRICE_2_SUCCESS",
  GET_LIST_OF_WHATSAPP_PRICE_2_ERROR: "GET_LIST_OF_WHATSAPP_PRICE_2_ERROR"
};

export const editWhatsappPrice2 = {
  EDIT_WHATSAPP_PRICE_2_REQUEST: "EDIT_WHATSAPP_PRICE_2_REQUEST",
  EDIT_WHATSAPP_PRICE_2_SUCCESS: "EDIT_WHATSAPP_PRICE_2_SUCCESS",
  EDIT_WHATSAPP_PRICE_2_ERROR: "EDIT_WHATSAPP_PRICE_2_ERROR"
};
